<div fxFlex='column'
     [mmTestId]="'PRODUCT_CATALOG.PROMOTION_FILTER'">
  <form [formGroup]='promotionForm'>
    <ul class='promotion-list' [ngClass]="{'new-design': isMobileOrTablet}">
      <app-search-filter-item
        *ngIf="blackDeal?.totalCount && isBlackDealsEnabled"
        [itemValue]="'blackDeal'"
        [hideCount]="isMobileOrTablet"
        [count]='blackDeal?.totalCount'>
        <mm-checkbox *ngIf="!isMobileOrTablet" [formControlName]="'blackDeal'"
                     [mmTestTarget]="'black-deal-filter'"
                     labelType='short'>
          <span class="filter-black-deals">{{'CATALOG.DETAILS_PAGE.BLACK_DEALS.LABEL' | translate}}</span>
        </mm-checkbox>
        <label *ngIf="isMobileOrTablet" class="filter__facet"
               [ngClass]="{'selected': promotionForm?.controls['blackDeal']?.value }">
          <input type="checkbox" class="filter__facet-checkbox"
                 [formControlName]="'blackDeal'">
          <span>{{'CATALOG.DETAILS_PAGE.BLACK_DEALS.LABEL' | translate}}</span>
          <mm-icon *ngIf="promotionForm?.controls['blackDeal']?.value"
                   class="filter-facets__clearicon" name="close_grey"></mm-icon>
        </label>
      </app-search-filter-item>
      <app-search-filter-item
        *ngIf="promotion?.totalCount"
        [itemValue]="'promotion'"
        [hideCount]="isMobileOrTablet"
        [count]='promotion?.totalCount'>
        <mm-checkbox *ngIf="!isMobileOrTablet" [formControlName]="'promotion'"
                     [mmTestTarget]="'promotion-filter'"
                     labelType='short'>
          {{'FILTERS.FILTER_TAGS.PROMTION_TAG.ON_SALE' | translate}}
        </mm-checkbox>
        <label *ngIf="isMobileOrTablet" class="filter__facet"
               [ngClass]="{'selected': promotionForm?.controls['promotion']?.value }">
          <input type="checkbox" class="filter__facet-checkbox"
                 [formControlName]="'promotion'">
          <span>{{'FILTERS.FILTER_TAGS.PROMTION_TAG.ON_SALE' | translate}}</span>
          <mm-icon *ngIf="promotionForm?.controls['promotion']?.value"
                   class="filter-facets__clearicon" name="close_grey"></mm-icon>
        </label>
      </app-search-filter-item>

      <app-search-filter-item
        *ngIf="volumePrices?.totalCount"
        [itemValue]="'volumePrices'"
        [hideCount]="isMobileOrTablet"
        [count]='volumePrices?.totalCount'>
        <mm-checkbox *ngIf="!isMobileOrTablet"
                     [formControlName]="'volumePrices'"
                     [mmTestTarget]="'volume-prices-filter'"
                     labelType='short'>
          {{'FILTERS.FILTER_TAGS.VOLUME_PRICE' | translate}}
        </mm-checkbox>
        <label *ngIf="isMobileOrTablet" class="filter__facet"
               [ngClass]="{'selected': promotionForm?.controls['volumePrices']?.value }">
          <input type="checkbox" class="filter__facet-checkbox"
                 [formControlName]="'volumePrices'">
          <span>{{'FILTERS.FILTER_TAGS.VOLUME_PRICE' | translate}}</span>
          <mm-icon *ngIf="promotionForm?.controls['volumePrices']?.value"
                   class="filter-facets__clearicon" name="close_grey"></mm-icon>
        </label>
      </app-search-filter-item>
      <app-search-filter-item
        *ngIf="rebuyGuarantee?.totalCount"
        [itemValue]="'rebuyGuarantee'"
        [hideCount]="isMobileOrTablet"
        [count]='rebuyGuarantee?.totalCount'>
        <div class="rebuy-guarantee__checkbox-container">
          <mm-checkbox *ngIf="!isMobileOrTablet"
                       [formControlName]="'rebuyGuarantee'"
                       [mmTestTarget]="'rebuy-guarantee-filter'"
                       labelType='short'>
            {{ rebuyGuarantee?.name }}
          </mm-checkbox>
          <app-tooltip *ngIf="isDesktop"
                       class="rebuy-guarantee__tooltip"
                       [position]="tooltipPosition"
                       [fontSize]="11"
                       [height]="14"
                       [width]="14"
                       [bulletIconName]="'icon_question_mark_plain'"
                       [bulletBackgroundColor]="bulletBackgroundColor">
            <p class="filter__rebuy-disclaimer">
              {{ 'CATALOG.FILTERS.REBUY_GUARANTEE.DISCLAIMER' | translate }}
            </p>
          </app-tooltip>
        </div>

        <label *ngIf="isMobileOrTablet" class="filter__facet"
               [ngClass]="{'selected': promotionForm?.controls['rebuyGuarantee']?.value }">
          <input type="checkbox" class="filter__facet-checkbox"
                 [formControlName]="'rebuyGuarantee'">
          <span>{{ rebuyGuarantee?.name }}</span>
          <mm-icon *ngIf="promotionForm?.controls['rebuyGuarantee']?.value"
                   class="filter-facets__clearicon" name="close_grey"></mm-icon>
        </label>
      </app-search-filter-item>
    </ul>
  </form>
  <p *ngIf="!isDesktop && rebuyGuarantee?.totalCount" class="filter__rebuy-disclaimer mobile">
    {{ 'CATALOG.FILTERS.REBUY_GUARANTEE.DISCLAIMER' | translate }}
  </p>
</div>



